import { Tooltip } from '@mui/material';
import { amber } from '@mui/material/colors';

interface Props {
  /** Custom tooltip text. Defaults to "Pending retailer approval" */
  tooltipText?: string;
  /** Size of the indicator in pixels. Defaults to 8 */
  size?: number;
}

/**
 * A small amber dot indicator that shows a field has pending changes awaiting retailer approval.
 * Used in the Line Item Wizard to indicate which fields have been modified but not yet approved.
 */
export default function PendingIndicator({
  tooltipText = 'Pending retailer approval',
  size = 8,
}: Props) {
  return (
    <Tooltip title={tooltipText}>
      <span
        style={{
          display: 'inline-block',
          width: size,
          height: size,
          borderRadius: '50%',
          backgroundColor: amber[500],
          marginLeft: 6,
          flexShrink: 0,
          cursor: 'help',
        }}
        aria-label={tooltipText}
      />
    </Tooltip>
  );
}
